import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@material-ui/core";
import React from "react";

const removerAcentos = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};


const FiltrarGrupoProduto = (props) => {
	const urlParams = new URLSearchParams(window.location.search);

	return (
		<React.Fragment>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<FormControl fullWidth>
						<TextField
							id="nome"
							name="nome"
							label="Filtrar..."
							autoComplete="off"
							fullWidth
							autoFocus
							value={
								props.formData && props.formData.nome ? props.formData.nome : ""
							}
							onChange={(e) =>
								props.SetFiltraDados({
									...props.formData,
									nome: e.target.value,
								})
							}
						/>
					</FormControl>
				</Grid>
      </Grid>
			<Grid container spacing={2}>
				{urlParams.get("astec_chamado_id") == null && (
					<Grid item xs={4}>
						<FormControl fullWidth>
							<InputLabel id="Categoria">Categoria</InputLabel>
							<Select
								labelId="Categoria"
								id="categoria"
								value={props.formData.categoria}
								onChange={(e) => {
									props.SetFiltraDados({
										...props.formData,
										categoria: e.target.value,
									});
								}}
							>
								<MenuItem value={""}>Todos</MenuItem>
								<MenuItem value={"Acessórios"}>Acessórios</MenuItem>
								<MenuItem value={"Equipamentos"}>Equipamentos</MenuItem>
								<MenuItem value={"Five"}>Five</MenuItem>
								<MenuItem value={"Móveis"}>Móveis</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				)}
        <Grid item xs={4}>
					<FormControl fullWidth>
						<InputLabel id="Linha">Linha</InputLabel>
						<Select
							labelId="Linha"
							id="linha"
							value={props.formData.linha}
							onChange={(e) =>
								props.SetFiltraDados({
									...props.formData,
									linha: e.target.value,
								})
							}
						>
              <MenuItem value={""}>Todos</MenuItem>
              {props.gruposDeProdutosLinha.map((item) => (
							  <MenuItem value={item.nome.toLowerCase()} key={item.id}>{item.nome}</MenuItem>
              ))}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={4}>
					<FormControl fullWidth>
						<InputLabel id="Cor">Cor</InputLabel>
						<Select
							labelId="Cor"
							id="cor"
							value={props.formData.cor}
							onChange={(e) =>
								props.SetFiltraDados({
									...props.formData,
									cor: e.target.value,
								})
							}
						>
              <MenuItem value={""}>Todos</MenuItem>
              {props.gruposDeProdutosCor.map((item) => (
							  <MenuItem value={removerAcentos(item.nome.toLowerCase())} key={item.id}>{item.nome}</MenuItem>
              ))}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default FiltrarGrupoProduto;
